import { InvestorKycDetail } from "../api/transformers/kyc";
import { KycAPI } from "../api";
import { useQuery } from "@tanstack/react-query";
import restUtils from "core/utils/rest";

function useInvestorKycStore(personId: string) {
  return useQuery<InvestorKycDetail>({
    queryKey: ["investorKyc", personId],
    queryFn: async () => {
      const result = await KycAPI.getInvestorKyc(personId);
      return result;
    },
    enabled: !!personId,
  });
}

export default useInvestorKycStore;

export function fetchInvestorKYC(personId: string): Promise<InvestorKycDetail> {
  return restUtils.call(
    "PortalApi",
    `hubwise-api/ims/investor/${personId}/kyc`,
    "GET"
  ).then((response) => {
    return response as InvestorKycDetail;
  });
}
